import axios from "axios";
import { SERVER_URL } from "../../../../config/env";
import authHeader from "../../../../2_ksbHub/utils/auth/auth-header";

const roomService = {
  /**
   * =========================================================
   * ✅ GET ROOMS
   * =========================================================
   */
  async getRooms() {
    const res = await axios.get(SERVER_URL + "bsz/rooms", {
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ CREATE ROOM
   * =========================================================
   */
  async createRoom(roomData) {
    const res = await axios.post(
      SERVER_URL + "bsz/rooms",
      {
        name: roomData.name,
        studentSlots: roomData.studentSlots,
        teacherSlots: roomData.teacherSlots,
        availability: roomData.availability,
      },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ UPDATE ROOM
   * =========================================================
   */
  async updateRoom(roomData) {
    const res = await axios.put(
      SERVER_URL + `bsz/rooms/${roomData.id}`,
      {
        name: roomData.name,
        studentSlots: roomData.studentSlots,
        teacherSlots: roomData.teacherSlots,
        availability: roomData.availability,
      },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ DELETE ROOM
   * =========================================================
   */
  async deleteRoom(roomId) {
    const res = await axios.delete(SERVER_URL + `bsz/rooms/${roomId}`, {
      headers: authHeader(),
    });

    return res.data;
  },

  /**
   * =========================================================
   * ✅ UPDATE ROOM LAYOUT
   * =========================================================
   */
  async updateRoomLayout(roomId, layout) {
    const res = await axios.put(
      SERVER_URL + `bsz/rooms/${roomId}/layout`,
      layout,
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },

  /**
   * =========================================================
   * ✅ BULK UPDATE ROOM LAYOUT
   * =========================================================
   */
  async updateRoomLayoutBulk(rows) {
    const res = await axios.post(
      SERVER_URL + "bsz/rooms/layout/bulk",
      { rows },
      {
        headers: authHeader(),
      },
    );

    return res.data;
  },
};

export default roomService;
